import { Component, inject, OnInit, ChangeDetectorRef, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Apollo } from "apollo-angular";
import { GET_ALERT_DASHBOARD_DATA } from "../../../../store/entities/warehouse-management/alert-dashboard/alert-dashboard.graphql";
import { AlertService } from "./alertService/alert-shared-service";

interface Alert {
  warehouseName: string;
  createdAt: string;
  status: string;
  alertType: string;
  reading: string;
}

@Component({
  selector: "app-alert-modal",
  templateUrl: "./alert-modal.component.html",
  styleUrl: "./alert-modal.component.scss",
})
export class AlertModalComponent implements OnInit {
  private dialogRef: MatDialogRef<AlertModalComponent> = inject(MatDialogRef);
  private apollo: Apollo = inject(Apollo);
  private alertService: AlertService = inject(AlertService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  public tableData: Alert[] = [];
  public columns;
  title: string = "";
  loading: boolean = true;
  refreshDataTable: boolean = false;

  tableConfiguration = {
    tableColumns: [
      { name: "warehouseName", label: "Warehouse" },
      { name: "alertsCount", label: "Count" },
      // { name: "status", label: "Status" },
      // { name: "reading", label: "Reading" },
      // { name: "alertType", label: "Alert Type" },
      // { name: "createdAt", label: "Created On" },
    ],
    tableCaption: "",
    showNumbers: true,
    tableNotifications: "Notification",
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: "Activate",
    empty_msg: "No data found",
  };

  ngOnInit() {
    this.fetchAlertData();
  }
  constructor(@Inject(MAT_DIALOG_DATA) private data) {

    console.log(data);

  }
  fetchAlertData() {
    this.loading = true;
    this.alertService.fetchAlertData();
    this.tableData = this.data.alertCount.alertsByWarehouse
    this.loading = false
    this.tableConfiguration.doneLoading = true
    this.cdr.detectChanges()

  }

  closeModal() {
    this.dialogRef.close();
  }
}
